export default "__VITE_ASSET__cc2561f5__"